export default "__VITE_ASSET__be20acHa__"